import {
    Card,
    Variant,
} from '@genomics-dev/denim-components';
import {FormattedMessage} from 'react-intl';

export function TalkToDoctorOption(props) {
    const {
        children,
        currentStep,
        dataTestId,
        title,
        totalSteps,
    } = props;

    return (
        <Card
            className={'talk-to-doctor-option'}
            dataTestId={dataTestId}
            variant={Variant.DARK}
        >
            <div>
                <div
                    className={'step is-caption is-heavy'}
                    data-test-id={`${dataTestId}-step`}
                >
                    <FormattedMessage
                        id={'common.optionOfTotal.text'}
                        values={{
                            currentStep,
                            totalSteps,
                        }}
                    />
                </div>
                <h4 data-test-id={`${dataTestId}-title`}>{title}</h4>
            </div>
            {children}
        </Card>
    );
}
